export default "__VITE_ASSET__b8188631__"